import BasePoint from "./BasePoint";

export default class Point extends BasePoint {
  constructor() {
    super();
    this.id = 0;
  }
}